module.exports = __webpack_public_path__ + "img/20190727140509210.1a11a4a0.png";